import axios from 'axios'
import configRequest from "@src/config/request-wordpress";
import formatErrorMessage from './format-response-message'
import { messageError } from "@utils/message";
import { MessageBox } from 'element-ui';
import router from "@router/index";
import Vue from "vue";
import liff from "@line/liff";
import store from '@store'

const baseURL = configRequest.baseURL;

let axiosInstance = axios.create();
axiosInstance.defaults.baseURL = baseURL;

console.log('INIT_API_PATH:', axiosInstance.defaults.baseURL);

axiosInstance.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axiosInstance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axiosInstance.interceptors.request.use(
  (axiosInstanceRequestConfig) => {
    const config = {
      ...configRequest,
      ...axiosInstanceRequestConfig,
    };

    const configName = config?.name || 'api';
    const isThrottle = config?.isThrottle || false;

    if(Vue.prototype.$isLoading(configName) && isThrottle) {
      return Promise.reject({
        config,
        response: {
          data: {
            code: 200,
            message: "Api Throttle",
            status: "API_THROTTLE",
            data: null
          }
        }
      });
    }

    Vue.prototype.$startLoading(configName);

    if(axiosInstance.defaults.baseURL !== config?.baseURL || baseURL) {
      axiosInstance.defaults.baseURL = config?.baseURL || baseURL;
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

axiosInstance.interceptors.response.use((response) => {
  const config = {
    ...configRequest,
    ...response.config,
  };

  setTimeout(() => {
    Vue.prototype.$endLoading(config.name || 'api');
  }, config.endLoadingDelay || 0);
  // return Promise.reject(response)
  return response.data?.data || response.data
}, errorResponseHandler);

function errorResponseHandler(error) {
  const {
    response
  } = error;

  const config = {
    ...configRequest,
    ...error.config,
  };

  Vue.prototype.$endLoading(config?.name || 'api');

  if(response && response.data.status !== 'API_THROTTLE') {
    if(!config.errorHandle) {
      return response.data
    }

    if(config.showMessage) {
      if(response.data.status === 'INPUT_INVALID') {
        const content = () => {
          const invalidData =
            response.data.data != null && typeof response.data.data === 'object' ? response.data.data : {}
          const level1 = Object.keys(invalidData);

          let level1Content = '';

          level1.forEach(level1Key => {
            const level2 = invalidData[level1Key];

            const level2Content = () => {
              let level2Content = '';

              if (Array.isArray(level2) && level2.length > 0) {
                level2.forEach(level2Text => {
                  level2Content += `<li>${level2Text}</li>`
                });

                return `<ul>${level2Content}</ul>`
              } else {
                return ''
              }
            };

            level1Content += `<li>${level1Key}${level2Content()}</li>`
          });

          return level1Content ? `<ol>${level1Content}</ol>` : '<p>請求參數驗證失敗</p>'
        };

        MessageBox.alert(content(), '欄位錯誤', {
          customClass: 'isStyleError',
          confirmButtonText: '確定',
          dangerouslyUseHTMLString: true
        })
      } else {
        messageError({
          title: '錯誤',
          content: formatErrorMessage(response.data?.status || ''),
          duration: 3000,
        });
      }
    }

    if(config.logoutRedirect && response.data.code === 405 || response.data.code === 401) {
      if(liff.isInClient()) {
        alert('登入權杖過期：請重新打開視窗');
        store.dispatch('auth/logOut')
        liff.closeWindow();
      } else {
        router.replace({
          name: 'shop-logout',
          query: {
            redirectFrom: location.pathname
          }
        })
      }

    }

    return Promise.reject(response.data)
  } else if(!window.navigator.onLine) {
    messageError('網路出了點問題，請重新連線後刷新頁面');
  } else {
    return Promise.reject(error)
  }
}

export default axiosInstance
